<template>
	<!-- myp-mb-button -->
	<main
		class="myp-assesscourses-container"
		:class="
			(activeTab == 1 && coursedata.length > 0) ||
			(activeTab == 0 && asmntdata.completedTests.length > 0)
				? 'myp-mb-button'
				: ''
		"
	>
		<div class="d-flex justify-content-between w-100">
			<b-tabs class="w-100" v-model="activeTab" @input="checkActiveTab">
				<b-tab active>
					<template #title>
						<img
							v-if="!activetabcolor"
							class="mr-2"
							src="../../assets/newdesign/myprofile/urAssessmentWhite.svg"
							alt=""
						/>
						<img
							v-else
							class="mr-2"
							src="../../assets/newdesign/myprofile/urAssessmentBlack.svg"
							alt=""
						/>
						Your assessments
					</template>

					<template v-if="shimmerAsses2">
						<div class="myp-asscou-table-overflow mt-3">
							<div v-for="i in 5" :key="'assessshim' + i">
								<b-skeleton class="w-25"></b-skeleton>
								<b-skeleton class="mr-4 w-15"></b-skeleton>
								<b-skeleton class="mr-4 w-15"></b-skeleton>
							</div>
						</div>
					</template>
					<template v-else>
						<section
							class="myp-ass-cou-nocourse mt-3"
							v-if="asmntdata.completedTests.length === 0"
						>
							<img
								src="../../assets/newdesign/myprofile/noAssCourse.svg"
								alt=""
							/>
							<span class="myp-grey-txt-2 my-3">No assessment to show!</span>
							<b-button class="myp-share-btn" @click="goToProgress"
								>Go to Assessment</b-button
							>
						</section>
						<section class="myp-asscou-table-overflow mt-3" v-else>
							<div
								v-for="asmntdetails in asmntdata.completedTests"
								:key="asmntdetails.testID"
							>
								<section
									class="myp-width-40 text-truncate myp-blue-txt text-capitalize"
								>
									{{ asmntdetails.testName }}
								</section>
								<section class="myp-width-60 d-flex">
									<span class="myp-flex-class-2">
										<span
											class="myp-blue-txt mob-font d-flex align-items-center gap-2"
										>
											<span
												class="myp-blue-txt mb-0 myp-yellow-color align-items-center text-truncate myp-w-20"
												v-if="!asmntdetails.evaluation"
											>
												<img
													id="hideinmobile"
													src="../../assets/newdesign/myprofile/pending.svg"
													alt=""
													class="mr-1"
												/>Pending Evaluation
											</span>
											<template v-else-if="asmntdetails.status.status == 2">
												<span
													class="myp-green-color text-truncate myp-w-25"
													v-if="
														asmntdetails.status.passingStatus.statusCode == 1
													"
													>Passed</span
												>
												<span
													class="myp-red-color text-truncate myp-w-25"
													v-else-if="
														asmntdetails.status.passingStatus.statusCode == 0
													"
													>Failed</span
												> </template
											>|<span class="myp-grey-color">Attempt</span
											><span>
												{{ asmntdetails.totalAttemptsSubmitted }} /
												{{ asmntdetails.status.maxnoattempts }}
											</span></span
										>
									</span>
									<span class="myp-flex-class-3 myp-grey-txt">
										{{
											formatDate(asmntdetails.lastCompletedDate)
										}}&nbsp;&nbsp;&nbsp;{{
											convertTime(asmntdetails.lastCompletedDate)
										}}</span
									>
								</section>
							</div>
						</section>
					</template>
				</b-tab>
				<b-tab>
					<template #title>
						<img
							v-if="!activetabcolor"
							class="mr-2"
							src="../../assets/newdesign/myprofile/urCoursesBlack.svg"
							alt=""
						/>
						<img
							v-else
							class="mr-2"
							src="../../assets/newdesign/myprofile/urCoursesWhite.svg"
							alt=""
						/>
						Your courses
					</template>
					<section
						class="myp-ass-cou-nocourse mt-3"
						v-if="coursedata.length === 0"
					>
						<img
							src="../../assets/newdesign/myprofile/noAssCourse.svg"
							alt=""
						/>
						<span class="myp-grey-txt-2 my-3">No courses to show!</span>
						<b-button @click="goToAllCourses" class="myp-share-btn"
							>Go to Courses</b-button
						>
					</section>
					<section class="myp-asscou-table-overflow mt-3" v-else>
						<div
							v-for="coursedetails in coursedata"
							:key="coursedetails.courseID"
						>
							<section
								class="myp-width-40 text-truncate myp-blue-txt text-capitalize"
							>
								{{ coursedetails.title }}
							</section>
							<section class="myp-width-60 d-flex">
								<span class="myp-flex-class-2">
									<span class="myp-blue-txt d-flex align-items-center gap-2"
										><span
											class="myp-green-color"
											v-if="coursedetails.progress == 100"
											>successfully Completed</span
										>
										<span
											class="myp-grey-color"
											v-else-if="coursedetails.progress == 0"
											>Yet to start</span
										>
										<span
											class="myp-yellow-color"
											v-else-if="
												coursedetails.progress > 1 ||
												coursedetails.progress < 100
											"
											>Ongoing</span
										>
									</span>
								</span>
								<span class="myp-flex-class-3 myp-grey-txt">
									{{ formatDate(coursedetails.enrolledAt) }}&nbsp;&nbsp;&nbsp;{{
										convertTime(coursedetails.enrolledAt)
									}}</span
								>
							</section>
						</div>
					</section>
				</b-tab>
			</b-tabs>
			<span
				v-if="activeTab == 0 && asmntdata.completedTests.length > 0"
				@click="goToProgress"
				id="hideinmobile"
				class="d-flex align-items-center myp-blue-txt view-submission pointer"
				>View all Submission
				<img
					class="ml-2"
					src="../../assets/newdesign/myprofile/blueRightArrow.svg"
					alt=""
			/></span>
			<span
				v-if="activeTab == 1 && coursedata.length > 0"
				@click="goToAllCourses"
				id="hideinmobile"
				class="d-flex align-items-center myp-blue-txt view-submission pointer"
				>View all Courses
				<img
					class="ml-2"
					src="../../assets/newdesign/myprofile/blueRightArrow.svg"
					alt=""
			/></span>
		</div>

		<b-button
			v-if="
				(activeTab == 1 && coursedata.length > 0) ||
				(activeTab == 0 && asmntdata.completedTests.length > 0)
			"
			@click="activeTab == 0 ? gotoAssessment() : goToAllCourses()"
			id="hideinlaptop"
			class="myp-share-btn myp-view-more-pos"
			>View more
			<img
				class="ml-1"
				src="../../assets/newdesign/myprofile/bluedownarrow.svg"
				alt=""
		/></b-button>
	</main>
</template>

<script>
import { getAssessmentData, postCourseList } from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import { config } from '@/config';
export default {
	data() {
		return {
			activeTab: 0,
			activetabcolor: false,
			asmntdata: {
				completedTests: [],
			},
			asmntdatadate: "",
			coursedata: [],
			formattedData: [],
			shimmerAsses2: true,
		};
	},
	created() {
		this.getAssessmentData();
		this.fetchCourse();
	},

	computed: {
		...mapGetters("userVUEX", {
			userinfo: "getUserInfo",
		}),
	},
	methods: {
		checkActiveTab() {
			this.activetabcolor = !this.activetabcolor;
		},
		async getAssessmentData() {
			try {
				let payload = {
					email: this.userinfo.email,
					count: 7,
				};
				const res = await getAssessmentData(payload);
				if (res.status == 200) {
					this.asmntdata = res.data.data;
				}
			} catch (error) {
				console.log(error);
			}
			this.shimmerAsses2 = false;
		},
		async fetchCourse() {
			const payload = {
				// We can put count
				// completed: false,
				count: 7,
				page: 0,
				sort: -1,
			};
			try {
				const res1 = await postCourseList(payload);
				if (res1.status == 200) {
					this.coursedata = res1.data.data.data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		formatDate(createdDate) {
			const date = new Date(createdDate);
			const day = String(date.getDate()).padStart(2, "0");
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const year = date.getFullYear();

			return `${day}/${month}/${year}`;
		},
		//converting into time string
		convertTime(timeString) {
			if (timeString != null) {
				const date = new Date(timeString);
				const hours = date.getHours();
				const minutes = date.getMinutes();
				// Format the time as "hrs:min" with minutes padded to two digits
				return `${hours}:${String(minutes).padStart(2, "0")}`;
			} else {
				return "0 min";
			}
		},
		goToProgress() {
			let queryObj = { ...this.$route.query, tab: "completed" };
			if (this.$route.name === "streaks" || this.$route.name === "mobstreaks") {
				queryObj.from = "streaks";
			}
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: queryObj,
			});
		},
		goToCourse(cData) {
			let link = `${config.trainingBase}/coursedetail/${
				cData.courseID || cData.referenceID
			}?courseName=${cData.title || cData.courseName}`;
			window.open(link, "_self");
		},
		goToAllCourses() {
			window.open(
				`${config.trainingBase}/filteredcoursesview`,
				"_self"
			);
		},
		gotoAssessment() {
			let queryObj = { ...this.$route.query, subCategoryTitle: "All Assessments" };
			if (this.$route.name === "streaks" || this.$route.name === "mobstreaks") {
				queryObj.from = "streaks";
			}
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: queryObj,
			});
		},
	},
};
</script>

<style>
.view-submission {
	position: absolute;
	top: 25px;
	right: 30px;
}
.myp-assesscourses-container {
	width: 100%;
	background-color: var(--bg-white);
	box-shadow: 0px 4px 8px 0px #00000029;
	border-radius: 8px;
	padding: 20px 0px 20px 20px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.myp-assesscourses-container .nav-tabs .nav-link.active,
.myp-assesscourses-container .nav-tabs .nav-item.show .nav-link {
	color: var(--bg-white);
	background-color: var(--bg-proTheme);
	border-radius: 6px;
	display: flex;
	align-items: center;
	border: none;
}

.myp-assesscourses-container .nav-tabs .nav-link {
	margin-bottom: 0;
	background-color: transparent;
	border: none;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: #40404c;
}
.myp-assesscourses-container .nav-tabs {
	border-bottom: none;
}

.myp-asscou-table-overflow {
	height: 233px;
	overflow: auto;
	padding-right: 15px;
	width: 100%;
}
.myp-asscou-table-overflow div {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	border-radius: 8px;
	padding: 15px;
}

.myp-asscou-table-overflow div:nth-child(odd) {
	background-color: #f7f7f8;
}
.myp-asscou-table-overflow div:nth-child(even) {
	background-color: var(--bg-white);
}

.myp-ass-cou-nocourse {
	background-image: url("../../assets/newdesign/myprofile/noAssCourBack.png");
	background-repeat: no-repeat;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 98%;
	padding-block: 20px;
	background-size: cover;
}
.myp-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--bg-proTheme);
}
.myp-grey-txt-2 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-LM);
	color: #595959;
}
.myp-share-btn.btn-secondary {
	background-color: var(--bg-white);
	border-radius: 40px;
	border: 1px solid var(--bg-proTheme);
	display: flex;
	align-items: center;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--bg-proTheme);
	padding: 7px 16px;
}
.myp-share-btn.btn-secondary:active {
	background-color: var(--bg-white) !important;
	color: var(--bg-proTheme) !important;
}
.myp-width-40 {
	width: 40%;
}
.myp-width-60 {
	width: 60%;
}
.myp-flex-class-2 {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 70%;
}

.myp-green-color {
	color: #44a798;
}

.myp-yellow-color {
	color: #ffa157;
}

.myp-red-color {
	color: #ad1927;
}

.myp-grey-color {
	color: #8c8c8c;
}

.myp-darkgrey-color {
	color: #5f5f5f;
}
.myp-flex-class-3 {
	display: flex;
	justify-content: flex-end;
	width: 30%;
}
.myp-grey-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-R);
	color: var(--cv-gray);
}
@media (max-width: 1028px) {
	.myp-assesscourses-container .nav-tabs .nav-link {
		font-size: var(--size-12);
		flex: 1;
	}
	.myp-asscou-table-overflow div {
		flex-direction: column;
		justify-content: unset;
		gap: 10px;
		width: 100%;
		border-radius: 8px;
		padding: 10px;
	}
	.myp-assesscourses-container {
		padding: 15px 0px 15px 15px;
	}
	.myp-assesscourses-container .tabs {
		padding-right: 15px;
	}
	.myp-assesscourses-container .nav-tabs {
		width: 100%;
		background-color: #f7f7f8;
		border-radius: 6px;
	}

	.myp-assesscourses-container ul li {
		width: calc(100% / 2);
	}
	.myp-assesscourses-container .nav-link {
		padding-inline: unset;
		text-align: center;
	}
	.myp-mb-button {
		margin-bottom: 10px;
	}
	.myp-asscou-table-overflow {
		min-height: 175px;
		height: unset;
		overflow: unset;
		padding-right: 0px;
	}

	.myp-view-more-pos {
		position: absolute;
		bottom: -15px;
	}

	.myp-ass-cou-nocourse {
		background-image: url("../../assets/newdesign/myprofile/noAssCourBackMobile.png");
		background-repeat: no-repeat;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding-block: 20px;
		background-size: cover;
	}
	.myp-w-25 {
		width: 25%;
	}
	.myp-w-20 {
		width: 20%;
	}
	.myp-grey-txt-2 {
		font-size: var(--size-14);
	}
	.myp-width-88,
	.myp-width-40,
	.myp-width-60 {
		width: 100%;
	}
	.myp-flex-class-2 {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: calc(100% - 124px);
	}
	.myp-flex-class-3 {
		display: flex;
		justify-content: flex-end;
		width: 124px;
	}
}
@media (max-width: 375px) {
	.myp-blue-txt.mob-font {
		font-size: 0.8rem;
	}
}
</style>
